import React from 'react';
import SummaryCard from '../../CustomDashboard/components/SummaryCard';

const SECTION_COLORS = ['#3f88a7', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'];

// Computes average intensity ratio (numerator / denominator) across all periods.
export const computeRatio = (row, denom, periods) => {
  const ratios = periods
    .map(p => {
      const n = row.timePeriods.find(t => t.period === p.label)?.value ?? null;
      const d = denom.timePeriods.find(t => t.period === p.label)?.value ?? null;
      return n != null && d != null && d !== 0 ? n / d : null;
    })
    .filter(v => v !== null);
  return {
    value: ratios.length ? ratios.reduce((a, b) => a + b, 0) / ratios.length : null,
    unit:  row.unit && denom.unit ? `${row.unit}/${denom.unit}` : row.unit || denom.unit || '',
  };
};

// Renders the summary tab: one SummaryCard per (numerator row × denominator) combination.
const IntensitySummaryCard = ({ tableGroups, filteredDenomData, filteredPeriods, cfgLabel }) => (
  <>
    {tableGroups.map(({ configId, cfg, topRows, kpiRows }, gi) => {
      const sectionColor = SECTION_COLORS[gi % SECTION_COLORS.length];
      return (
        <div key={configId} style={{ marginBottom: 28 }}>

          {/* Group header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14, paddingBottom: 8, borderBottom: `2px solid ${sectionColor}20` }}>
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: sectionColor, flexShrink: 0, display: 'inline-block' }} />
            <span style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>{cfgLabel(cfg)}</span>
            {topRows[0]?.unit && (
              <span style={{ fontSize: 10, fontWeight: 600, background: '#f3e8ff', color: '#6b21a8', borderRadius: 4, padding: '1px 6px', textTransform: 'uppercase' }}>
                {topRows[0].unit}
              </span>
            )}
          </div>

          {/* Top-level rows */}
          {topRows.map((row, ri) => (
            <div key={ri} style={{ marginBottom: kpiRows.length ? 16 : 0 }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
                {filteredDenomData.map(denom => {
                  const { value, unit } = computeRatio(row, denom, filteredPeriods);
                  return (
                    <SummaryCard
                      key={denom.title}
                      meta={{ title: `${row.label} per ${denom.title}` }}
                      accentColor={sectionColor}
                      data={value !== null ? [{ sum_value: value, unit }] : null}
                      showActionButton={false}
                    />
                  );
                })}
              </div>
            </div>
          ))}

          {/* KPI rows — indented under their top-level group */}
          {kpiRows.length > 0 && (
            <div style={{ paddingLeft: 16, borderLeft: `2px solid ${sectionColor}40`, marginTop: 12, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {kpiRows.map((row, ri) => (
                <div key={ri}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: sectionColor, opacity: 0.7, flexShrink: 0, display: 'inline-block' }} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>{row.label}</span>
                    {row.unit && (
                      <span style={{ fontSize: 10, fontWeight: 600, background: '#f3e8ff', color: '#6b21a8', borderRadius: 4, padding: '1px 6px', textTransform: 'uppercase' }}>
                        {row.unit}
                      </span>
                    )}
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
                    {filteredDenomData.map(denom => {
                      const { value, unit } = computeRatio(row, denom, filteredPeriods);
                      return (
                        <SummaryCard
                          key={denom.title}
                          meta={{ title: `${row.label} per ${denom.title}` }}
                          accentColor={sectionColor}
                          data={value !== null ? [{ sum_value: value, unit }] : null}
                          showActionButton={false}
                        />
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    })}
  </>
);

export default IntensitySummaryCard;
